export default "__VITE_ASSET__Ckv3ZPTZ__"